const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBirthdayHat6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450.52,
    height: "160mm",
    viewBox: "0 0 119.2 160",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m98.789 57.607-6.498-26.783 12.097.31z",
    style: {
      fill: "#ee3264",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.988 57.054 14.337-24.772 10.305 4.647z",
    style: {
      fill: "#feb1b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.724 57.127 82.607 33.584 73.7 40.122z",
    style: {
      fill: "#35b1f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.027 56.045 28.871-11.664 2.988 8.567z",
    style: {
      fill: "#ee3264",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.341 55.75 73.248 46.15l-4.032 8.67z",
    style: {
      fill: "#feb1b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.58 174.044 98.647 53.33l-60.269 120.14s1.69 16.78 62.057 17.343c51.457.478 57.143-16.77 57.143-16.77",
    style: {
      fill: "#35b1f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.84 180.56c-8 3.891-16.7 7.268-25.893 10.091-20.846-.717-33.74-3.525-41.705-6.67 19.177-3.499 37.267-9.096 52.941-16.517 15.004-7.102 28.205-15.025 38.439-24.06l7.768 15.91c-8.527 8.016-19.184 15.234-31.55 21.246",
    style: {
      fill: "#feb1b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.923 153.916c15.917-7.536 29.806-15.993 40.273-25.723l7.733 15.84c-8.806 8.708-20.102 16.536-33.349 22.98-16.75 8.145-36.558 14.05-57.534 17.277-13.07-4.92-13.667-10.82-13.667-10.82l1.32-2.632c20.023-3.462 38.929-9.208 55.224-16.922",
    style: {
      fill: "#ee3264",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.09 152.795c-17.742 8.63-38.92 14.742-61.278 17.823l8.861-17.672c13.533-3.37 26.293-7.819 37.758-13.248 16.46-7.794 30.755-16.573 41.332-26.727l7.715 15.8c-8.95 9.128-20.613 17.324-34.389 24.024",
    style: {
      fill: "#35b1f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.862 154.564 10.114-20.159c6.544-2.27 12.817-4.815 18.743-7.62 17.685-8.373 32.865-17.878 43.628-29.008l7.666 15.708c-9.204 10.081-21.675 19.118-36.632 26.396-12.965 6.304-27.764 11.265-43.519 14.683",
    style: {
      fill: "#feb1b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.826 82.377 7.634 15.634c-9.345 10.857-22.437 20.586-38.343 28.322-7.747 3.767-16.15 7.053-25.016 9.818l11.854-23.634c18.009-8.66 33.33-18.53 43.871-30.14M106.035 68.466c-6.738 7.767-15.399 14.952-25.633 21.237L98.644 53.33l7.391 15.135",
    style: {
      fill: "#ee3264",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.333 67.03 7.62 15.603c-9.402 11.322-22.853 21.47-39.324 29.482a166.718 166.718 0 0 1-5.814 2.68l14.242-28.393c9.21-5.897 17.12-12.317 23.276-19.372",
    style: {
      fill: "#35b1f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.652 189.74c-6.35-.62-11.701-1.468-16.21-2.456 4.509.988 9.86 1.836 16.21 2.455m-16.21-2.455-.063-.015.063.015m-.11-.024c-.003 0-.006 0-.013-.003.007.003.01.003.014.003",
    style: {
      fill: "#9cd9f8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.652 189.74c-6.35-.62-11.701-1.468-16.21-2.456l-.063-.015c-.018-.003-.032-.005-.046-.01-.004 0-.007 0-.014-.003-4.078-.897-7.461-1.908-10.27-2.967 9.663-1.487 19.075-3.542 28.057-6.121l-1.454 11.57",
    style: {
      fill: "#ffd9d9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.05 184.29a49.17 49.17 0 0 1-2.6-1.06l6.773-15.462c9.06-1.909 17.812-4.325 26.095-7.213l-2.212 17.614c-8.982 2.579-18.394 4.634-28.057 6.121",
    style: {
      fill: "#f79bb3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.223 167.768 7.57-17.285c7.236-2.152 14.179-4.649 20.726-7.465l-2.201 17.537c-8.283 2.888-17.036 5.304-26.095 7.213",
    style: {
      fill: "#9cd9f8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.793 150.483 8.7-19.852a163.377 163.377 0 0 0 9.624-4.298 152.428 152.428 0 0 0 4.805-2.443l-2.403 19.128c-6.547 2.816-13.49 5.313-20.726 7.465",
    style: {
      fill: "#ffd9d9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.493 130.631 10.216-23.324a136.78 136.78 0 0 0 6.823-4.19l-2.61 20.773c-1.57.834-3.172 1.648-4.805 2.443a163.377 163.377 0 0 1-9.624 4.298",
    style: {
      fill: "#f79bb3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.71 107.307 8.822-20.142-2 15.951a136.78 136.78 0 0 1-6.823 4.191",
    style: {
      fill: "#9cd9f8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.33 190.812h-.049.05m-.113 0c-.025 0-.046-.003-.074-.003.028 0 .05.003.074.003m-.148-.003h-.046.046m-.124-.003h-.032.032m57.633-16.763-7.19-14.73 7.19 14.73",
    style: {
      fill: "#cdcfd1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.528 190.824c-.684 0-1.386-.005-2.092-.01-.035-.003-.07-.003-.105-.003h-.113c-.025 0-.046-.003-.074-.003h-.12c-.025 0-.05 0-.078-.003h-.032c-2.564-.027-5.02-.085-7.376-.17l.409.014c9.193-2.823 17.893-6.2 25.894-10.09 12.365-6.013 23.022-13.231 31.549-21.247l7.19 14.73s-5.525 16.78-55.052 16.78",
    style: {
      fill: "#3293c5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.947 190.651-.41-.015c3.857-6.385 7.391-13.362 10.535-20.637a160.987 160.987 0 0 0 6.508-2.986c13.247-6.444 24.543-14.272 33.349-22.98l7.46 15.28c-8.526 8.017-19.183 15.235-31.548 21.247-8.001 3.891-16.7 7.268-25.894 10.091",
    style: {
      fill: "#cc9396",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.072 170a209.626 209.626 0 0 0 8.265-22.69c9.374-5.513 17.505-11.771 24.14-18.539l7.452 15.262c-8.806 8.708-20.102 16.536-33.349 22.98a160.973 160.973 0 0 1-6.508 2.986",
    style: {
      fill: "#c0315a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.658 125.048-5.895-12.077c0 .003 0 0 0 0l-2.752-5.64-1.866-3.82 10.513 21.537",
    style: {
      fill: "#cdcfd1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.763 112.97-2.752-5.638 2.752 5.639",
    style: {
      fill: "#3293c5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.347 97.777-1.598-3.266 1.598 3.266",
    style: {
      fill: "#cdcfd1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.347 97.777-1.598-3.266 1.598 3.266M111.337 147.31c2.371-7.89 4.248-15.801 5.55-23.415 4.102-3.313 7.824-6.794 11.126-10.41l-.25-.514s0 .003 0 0l5.895 12.077 1.82 3.723c-6.636 6.768-14.767 13.026-24.14 18.538",
    style: {
      fill: "#3293c5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.886 123.895c1.468-8.601 2.205-16.822 2.092-24.209.505-.556.999-1.114 1.482-1.675l-.113-.234 2.798 5.734 1.866 3.82 2.752 5.64.25.514c-3.302 3.616-7.024 7.097-11.126 10.41",
    style: {
      fill: "#cc9396",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.978 99.686a83.83 83.83 0 0 0-.229-5.175l1.598 3.266.113.234c-.483.561-.977 1.12-1.482 1.675",
    style: {
      fill: "#c0315a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293267
    },
    transform: "translate(-38.38 -30.824)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdayHat6);
export default __webpack_public_path__ + "static/media/birthday_hat_6.c599240daf480ba6d6065353e42ee5bc.svg";
export { ForwardRef as ReactComponent };